var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("table", { staticClass: "table table-striped" }, [
    _c("thead", [
      _c("tr", [
        _c("th", { attrs: { scope: "col" } }, [_vm._v("#")]),
        _vm._v(" "),
        _vm.showActive
          ? _c("th", { attrs: { scope: "col" } }, [_vm._v("Active")])
          : _vm._e(),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Email")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Display name")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("First")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Last")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("User type")]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "tbody",
      _vm._l(_vm.users, function (u, i) {
        return _c("tr", { key: u.UserId }, [
          _c("th", { attrs: { scope: "row" } }, [_vm._v(_vm._s(i + 1))]),
          _vm._v(" "),
          _vm.showActive
            ? _c("td", [
                _vm._v(_vm._s(!u.IsLocked && !u.Deleted ? "Yes" : "No")),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("td", [
            u.OrganizationUnitId
              ? _c(
                  "a",
                  {
                    attrs: {
                      href: `/#/admin/organizations/users/manage/${u.OrganizationUnitId}/${u.UserId}`,
                    },
                  },
                  [_vm._v(_vm._s(u.Email))]
                )
              : _c(
                  "a",
                  {
                    attrs: {
                      href: `/#/admin/organizations/users/manage/${u.UserId}`,
                    },
                  },
                  [_vm._v(_vm._s(u.Email))]
                ),
          ]),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(u.DisplayName))]),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(u.FirstName))]),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(u.LastName))]),
          _vm._v(" "),
          _c("td", [
            u.IsGlobalAdmin
              ? _c(
                  "span",
                  {
                    staticClass: "badge badge-secondary",
                    attrs: { title: "Global Admin" },
                  },
                  [_vm._v("GA")]
                )
              : _vm._e(),
            _vm._v(" "),
            u.IsOrganizationAdmin
              ? _c(
                  "span",
                  {
                    staticClass: "badge badge-secondary",
                    attrs: { title: "Organization Admin" },
                  },
                  [_vm._v("OA")]
                )
              : _vm._e(),
            _vm._v(" "),
            u.IsWorkspaceUser
              ? _c(
                  "span",
                  {
                    staticClass: "badge badge-secondary",
                    attrs: { title: "Workspace User" },
                  },
                  [_vm._v("WU")]
                )
              : _vm._e(),
            _vm._v(" "),
            u.IsBusinessUser
              ? _c(
                  "span",
                  {
                    staticClass: "badge badge-secondary",
                    attrs: { title: "Business User" },
                  },
                  [_vm._v("BU")]
                )
              : _vm._e(),
            _vm._v(" "),
            u.IsServiceUser
              ? _c(
                  "span",
                  {
                    staticClass: "badge badge-info",
                    attrs: { title: "Service User" },
                  },
                  [_vm._v("SU")]
                )
              : _vm._e(),
          ]),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }